$(document).on('click', '.js-show-more', (e) => {
  const $target = $(e.currentTarget)

  $target.hide()
  $target.siblings('.js-show-more-content').show()
})
